import { jsx as z } from "react/jsx-runtime";
import { c as G } from "./index-65016bfa.mjs";
import { useRef as a, useEffect as K } from "react";
import "@fcamna/shared-component-foundations";
import { u as J } from "./useClient-0bbce34e.mjs";
import { u as w } from "./useSlots-a1aa6a84.mjs";
import { g as y } from "./isClient-ec947a14.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
var l = /* @__PURE__ */ ((e) => (e.TAB = "tab", e.ARROW = "arrow", e.BOTH = "both", e))(l || {});
const rr = ({
  open: e,
  navigationType: i = l.TAB,
  selector: H,
  ignoredSelector: g,
  disableAutoFocus: h,
  disableEnforceFocus: m,
  disableRestoreFocus: I,
  disableFocusCycle: E,
  disableScrollFocusInView: R,
  getFocusableElements: x,
  onFocusedOutside: b,
  children: D,
  className: M,
  style: U,
  ...W
}) => {
  const d = a(null), o = a([]), P = a(null), j = a(null), p = a(null), A = a(0), c = J();
  K(() => {
    var r;
    if (!(I || !e))
      return p.current = (r = c.document) == null ? void 0 : r.activeElement, () => {
        p.current && (p.current.focus(), p.current = null);
      };
  }, [c, I, e]), K(() => {
    var f, u, T;
    if (!e)
      return;
    const r = y(d);
    if (!r)
      return;
    const t = r.querySelectorAll(H || "a[href], button, textarea, input, select, [tabindex]"), n = Array.from(t).filter((s) => !s.hasAttribute("disabled") && s.offsetParent !== null).filter((s) => s.tabIndex >= 0).sort((s, k) => s.tabIndex === 0 && k.tabIndex !== 0 ? 1 : s.tabIndex !== 0 && k.tabIndex === 0 ? -1 : s.tabIndex - k.tabIndex);
    o.current = n, x == null || x(n), !h && (!((f = c.document) != null && f.activeElement) || !r.contains((u = c.document) == null ? void 0 : u.activeElement)) && ((T = n[0]) == null || T.focus()), P.current = n[0], j.current = n[n.length - 1];
  }, [h, e, d, D, x, i, H, g, c]);
  const B = (r) => {
    if (r.target === window)
      return;
    const t = y(d);
    if (!t || t.contains(r.target))
      return;
    if (m)
      return b == null ? void 0 : b(r);
    r.preventDefault(), r.stopPropagation();
    const n = o.current[A.current] || P.current;
    n == null || n.focus(), !R && n && (n.style.scrollMarginBlock = "40dvh", n.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" }), n.style.scrollMarginBlock = "");
  }, N = (r) => {
    if (r.target === window)
      return;
    const t = y(d);
    if (!t || m && !t.contains(r.target) || g && r.target.matches(g))
      return;
    const n = t.querySelectorAll(".FocusTrap.FocusTrap--open");
    if (Array.from(n).some((u) => u.contains(r.target)))
      return;
    const f = Array.from(o.current).indexOf(r.target);
    if (!(f === -1 && m)) {
      if (r.preventDefault(), r.stopPropagation(), f === -1 && !m) {
        const u = o.current.find((T) => T.contains(r.target)) || o.current[A.current];
        u == null || u.focus();
        return;
      }
      return f;
    }
  }, O = (r) => {
    var n;
    if (E && r === o.current.length - 1)
      return;
    const t = (r + 1) % o.current.length;
    A.current = t, (n = o.current[t]) == null || n.focus();
  }, q = (r) => {
    var n;
    if (E && r === 0)
      return;
    const t = (r - 1 + o.current.length) % o.current.length;
    A.current = t, (n = o.current[t]) == null || n.focus();
  }, C = (r) => {
    if (r.code !== "Tab")
      return;
    const t = N(r);
    t !== void 0 && (r.shiftKey ? r.shiftKey && q(t) : O(t));
  }, L = (r) => {
    if (!["ArrowDown", "ArrowUp", "Tab"].includes(r.code))
      return;
    const t = N(r);
    t !== void 0 && (r.code === "ArrowDown" ? O(t) : r.code === "ArrowUp" && q(t));
  };
  w("click", B, e && c.window, !0), w("pointerdown", B, e && c.window, !0), w("focusin", B, e && c.window, !0);
  const V = i === l.TAB || i === l.BOTH, $ = i === l.ARROW || i === l.BOTH;
  return w("keydown", C, e && V && c.window, !0), w("keydown", L, e && $ && c.window, !0), /* @__PURE__ */ z(
    "section",
    {
      ...W,
      ref: d,
      style: { ...U, display: "contents" },
      className: G([
        "FocusTrap",
        `FocusTrap--navigationType-${i}`,
        {
          "FocusTrap--open": e,
          "FocusTrap--disableAutoFocus": h,
          "FocusTrap--disableEnforceFocus": m,
          "FocusTrap--disableRestoreFocus": I,
          "FocusTrap--disableScrollFocusInView": R
        },
        M
      ]),
      children: D
    }
  );
};
export {
  rr as FocusTrap,
  l as FocusTrapNavigationType
};
